import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';
import { BodyM } from 'atoms/typography';
import { CreditCardIcon } from 'components/paymentMethods/Icon/CreditCardIcon';

const Text = styled(BodyM)`
  text-align: left;
`;

export const CreditCardLabel = () => {
  return (
    <Vertical gap={0.5}>
      <CreditCardIcon />
      <Text color="var(--c-neutral-1000)">
        <FormattedMessage
          id="CreditCardLabel.title"
          defaultMessage="Credit card"
        />
      </Text>
    </Vertical>
  );
};
